// extracted by mini-css-extract-plugin
export default {"images-container":"_2Ehjc"};